export type SubscriptionTier = "trial" | "solo" | "professional" | "team";

export interface TierPricing {
  monthly: number;
  annual: number;
}

export const TIER_PRICING: Record<SubscriptionTier, TierPricing> = {
  trial: {
    monthly: 0,
    annual: 0,
  },
  solo: {
    monthly: 39,
    annual: 374, // ~20% savings ($39 × 12 = $468 vs $374)
  },
  professional: {
    monthly: 69,
    annual: 663, // ~20% savings ($69 × 12 = $828 vs $663)
  },
  team: {
    monthly: 149,
    annual: 1430, // ~20% savings ($149 × 12 = $1,788 vs $1,430)
  },
};

// Helper function to get price by tier and billing period
export function getTierPrice(
  tier: SubscriptionTier,
  billingPeriod: "monthly" | "annual"
): number {
  return TIER_PRICING[tier][billingPeriod];
}

// Calculate annual savings percentage
export function getAnnualSavingsPercentage(tier: SubscriptionTier): number {
  const monthly = TIER_PRICING[tier].monthly;
  const annual = TIER_PRICING[tier].annual;
  
  if (monthly === 0) return 0;
  
  const monthlyTotal = monthly * 12;
  const savings = ((monthlyTotal - annual) / monthlyTotal) * 100;
  return Math.round(savings);
}

// Get monthly equivalent for annual pricing
export function getMonthlyEquivalent(tier: SubscriptionTier): number {
  const annual = TIER_PRICING[tier].annual;
  return Math.round(annual / 12);
}

// Pricing display constants
export const PRICING_CONSTANTS = {
  minMonthlyPrice: TIER_PRICING.solo.monthly,
  maxMonthlyPrice: TIER_PRICING.team.monthly,
  displayRange: `$${TIER_PRICING.solo.monthly}-$${TIER_PRICING.team.monthly}/month`,
  startingPrice: `Starting at $${TIER_PRICING.solo.monthly}/month`,
  fromPrice: `From $${TIER_PRICING.solo.monthly}/mo`,
};
